<template>
  <div
    v-if="action.attachments && action.attachments.length"
    class="content__message--fileAttachment content__message--item"
  >
    <div class="jobInfoAttachment">
      <div
        v-for="vbAttachment in action.attachments"
        v-bind:key="vbAttachment.id"
        class="file-uploaded input-none__border"
      >
        <div class="file clickable flex-row flex__between padding-0">
          <a
            class="flex-row flex__left margin-left-10"
            @click="downloadFile(vbAttachment)"
          >
            <file-type-image
              :fileExtention="vbAttachment.fileExtention"
              :customClass="''"
            />
            <span class="">{{ vbAttachment.fileName }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../filters/buildAttachmentURL";
import FileTypeImage from "../common/FileTypeImage";
import downloadService from "../../services/downloadService";

export default {
  name: "actionLogAttachments",
  components: { FileTypeImage },
  props: ["action"],
  filters: { buildAttachmentURL },
  mixins: [vbAttachmentTokenMixin],
  data() {
    return {};
  },

  methods: {
    downloadFile(attachment) {
      downloadService.downloadFileForAttachmentComment(attachment.id);
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/actionLogAttachments.vue